import styles from "./NewGalleryForm.module.scss";
import * as React from "react";

import LogoContainer from "../LogoContainer";
import ActionLink from "../ActionLink";
import TextInput from "../TextInput";
import Submit from "../Submit";

export interface NewGalleryFormProps {
    default_shipping_address?: string;
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    onCancel: () => void;
    is_trial: boolean;
    error?: string;
}

export const NewGalleryForm = (props: NewGalleryFormProps) => {
    return (
        <div className={styles["new-gallery-form"]}>
            <LogoContainer />

            <h2>You&apos;re almost done!</h2>

            {props.error ? (
                <p style={{color: "#fb9590"}}>{props.error}</p>
            ) : (
                <p>Please name your gallery and enter your event date.</p>
            )}

            <form onSubmit={props.onSubmit}>
                {props.is_trial ? null : (
                    <TextInput
                        name="display_name"
                        placeholder="Gallery Name (e.g. The Smith Wedding)"
                        help="Name Your Gallery"
                        nocomplete
                        required
                        onChange={props.onChange} />
                )}
                {props.is_trial ? null : (
                    <TextInput
                        name="date"
                        type="date"
                        required
                        placeholder="Your Wedding or Event Date"
                        help="Enter Your Wedding or Event Date"
                        onChange={props.onChange} />
                )}

                <Submit label="Continue" />
            </form>

            <ActionLink secondary onClick={props.onCancel} className={styles["new-gallery-form__cancel"]}>
                cancel
            </ActionLink>
        </div>
    );
};

export default NewGalleryForm;
